<template>
  <div class="expList">
    <div class="head">
      <p>成为第<span>&nbsp;{{explistData.orderNumber}}&nbsp;</span>名体验官</p>
      <img width="100%" :src='require("../../assets/images/common/a1.jpg")' />
    </div>
    <div class="gift">
      <p>{{explistData.openingRemaining}}</p>
      <img width="100%" :src='require("../../assets/images/common/a2.jpg")' />
    </div>
    <div class="main">
      <ul>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
        <li>
          <div class="m1">
            <div class="mLeft">
              <h2>享道出行体验券</h2>
              <p>有效期：2018.11.18-2018.12.08</p>
            </div>
            <div class="price">
              ¥&nbsp;<span>30</span>
            </div>
          </div>
          <div class="m2">限上海地区使用</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getDay } from '@/data/api/experince'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
import Cookie from '@/common/utils/Cookie.js'
export default {
  name: 'ExperienceExpdetailPage',
  data () {
    return {
      explistData: {
        openingRemaining: '',
        orderNumber: '',
        form: {
          // passengerId: '1029645464998257159'
        }
      }
    }
  },
  mounted () {
    this.getDays()
    this.updateToken()
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: true})
  },
  methods: {
    // URL是否带token 带则更新cookie
    updateToken () {
      if (this.$route.query.token) {
        const TokenKey = 'Admin-Token'
        Cookie.set(TokenKey, this.$route.query.token)
      }
    },
    getDays: function () {
      this.$mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      getDay(this.explistData.form).then((response) => {
        this.explistData.openingRemaining = response.openingRemaining
        this.explistData.orderNumber = response.rank
      }).catch(() => {}).finally(() => {
        this.$mint.Indicator.close()
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.expList {
  img{
    display: block;
  }
  .head{
    position: relative;
    p{
      position: absolute;
      top: 4.8rem;
      width: 100%;
      text-align: center;
      font-size: 1rem;
      color: #fff;
      span{
        font-size: 1.3rem;
      }
    }
  }
  .gift{
    position: relative;
    z-index: 10;
    top:-1px;
    p{
      position:absolute;
      width:100%;
      text-align: center;
      color:#fff;
      font-size:5.5rem;
      top:-6rem
    }
  }
  .main{
    li{
      background-color: #fff;
      border-radius: 5px;
      padding: 0 15px;
      margin-bottom: 15px;
      .m1{
        padding: 15px 0 10px;
        border-bottom: 1px dotted #ddd;
        overflow: hidden;
        .mLeft{
          float: left;
          h2{
            color: #333;
            font-size: 1rem;
          }
          p{
            color: #999;
            font-size: 0.75rem;
          }
        }
        .price{
          float: right;
          color: #00b2a9;
          font-family: Arial, Helvetica, sans-serif;
          span{
            font-size: 2rem;
          }
        }
      }
      .m2{
        padding: 10px 0;
        font-size: 0.7rem;
        color: #aaa;
      }
    }
    margin-top:-2px;
    bottom: 0;
    padding: 15px;
    background: linear-gradient(-158.1deg,rgba(61,189,198,1),rgba(147,217,217,1));
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Experience/expdetail.vue